import React from 'react'

export default function CancelRoom() {
  return (
    <div>
      
    </div>
  )
}
